import { cx } from '@orn/shared-web/utils/cx';
import * as React from 'react';

import { useDeviceBreakpoints } from '../../../hooks/useDeviceBreakpoints';
import { toCurrency } from '../../../utils/formatting';

export interface IChartHeaderProps extends React.PropsWithChildren {
  title: string;
  subtitle?: string;
  value?: string | number;
  className?: string;
}

export const ChartHeader = ({ title, subtitle, value, className = '', children }: IChartHeaderProps) => {
  const containerRef = React.useRef<HTMLDivElement>(null);
  const { isMobile } = useDeviceBreakpoints();

  // Format values for display
  const formattedValue = value !== undefined ? toCurrency(value) : undefined;

  return (
    <div ref={containerRef} className={cx('bg-secondary border-tertiary flex flex-col gap-5 border-b', className)}>
      <div className="flex flex-col gap-5 p-5">
        {/* Mobile Layout — title + value on row 1, children on row 2 */}
        {isMobile && (
          <div className="flex flex-col gap-2">
            <div className="flex items-baseline justify-between gap-4">
              <div className="flex flex-col gap-1">
                <div className="text-primary text-lg font-semibold">{title}</div>
                {subtitle && <span className="text-tertiary text-xs font-medium">{subtitle}</span>}
              </div>
              {formattedValue && <div className="text-primary text-xl font-semibold">{formattedValue}</div>}
            </div>

            {children && <div className="flex items-center">{children}</div>}
          </div>
        )}

        {/* Desktop Layout */}
        {!isMobile && (
          <div className="flex w-full items-center justify-between gap-4">
            <div className="flex flex-col gap-1">
              <div className="text-primary text-lg font-semibold">{title}</div>
              {subtitle && <span className="text-tertiary text-xs font-medium">{subtitle}</span>}
            </div>

            <div className="flex items-center gap-3">
              {formattedValue && <div className="text-primary text-xl font-semibold">{formattedValue}</div>}
              {children}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
